import { __decorate } from "tslib";
import { Component, EventEmitter, Input, Output } from '@angular/core';
let InputSwitchComponent = class InputSwitchComponent {
    model = false;
    styleClass;
    modelChange = new EventEmitter();
    handleChange($event) {
        this.modelChange.emit($event.checked);
    }
    static propDecorators = {
        model: [{ type: Input }],
        styleClass: [{ type: Input }],
        modelChange: [{ type: Output }]
    };
};
InputSwitchComponent = __decorate([
    Component({
        selector: 'inputSwitch',
        template: `
  <p-inputSwitch [(ngModel)]="model" (onChange)="handleChange($event)" [styleClass]="styleClass"></p-inputSwitch>
  `,
    })
], InputSwitchComponent);
export { InputSwitchComponent };
